export default __webpack_public_path__ + "static/media/resume.4b700f43.pdf";